import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import IPropTypes from 'react-immutable-proptypes'

import CloseButton from '../../../../../../../../components/CloseButton'
import { CLOSE_GROUP_STACK } from '../../../../constants'

import FilterButton from './components/FilterButton'
import Button from './components/Button'

import { BUTTONS, LOCALE_PREFIX } from './constants'

import './style.scss'

export default class ButtonsArea extends Component {
    static propTypes = {
        deleteAllGroupMembers: PropTypes.func.isRequired,
        groupId: PropTypes.number.isRequired,
        groupName: PropTypes.string.isRequired,
        groupStackState: PropTypes.object.isRequired,
        isMonitored: PropTypes.bool.isRequired,
        members: IPropTypes.list.isRequired,
        openDialog: PropTypes.func.isRequired,
        removeGroupMonitoring: PropTypes.func.isRequired,
        toggleGroupStack: PropTypes.func.isRequired,
    }

    constructor() {
        super()
        this.state = { groupButtonHover: false }
    }

    getMonitorButtonText = () => {
        const {
            isMonitored,
            groupStackState: {
                groupData: { loading },
            },
        } = this.props
        const { groupButtonHover } = this.state

        if (loading && isMonitored) {
            return `${LOCALE_PREFIX}.monitored`
        }
        if (loading && !isMonitored) {
            return `${LOCALE_PREFIX}.notMonitored`
        }

        return (isMonitored && groupButtonHover) || (!isMonitored && !groupButtonHover)
            ? `${LOCALE_PREFIX}.notMonitored`
            : `${LOCALE_PREFIX}.monitored`
    }

    handleCloseGroupStack = () => {
        const { toggleGroupStack } = this.props

        toggleGroupStack(CLOSE_GROUP_STACK)
    }

    handleDeleteAllGroupMembers = () => {
        const {
            deleteAllGroupMembers,
            groupStackState: { activeGroup },
        } = this.props

        deleteAllGroupMembers(activeGroup)
    }

    handleImportGroupMembers = () => {
        const { openDialog } = this.props

        openDialog('groupMembersImport')
    }

    handleMonitorGroup = () => {
        const { openDialog, isMonitored, removeGroupMonitoring } = this.props

        if (isMonitored) {
            removeGroupMonitoring()
        } else {
            openDialog('groupMonitoring')
        }
    }

    handleExportGroup = () => {
        const { groupStackExportMembers, groupName, groupId } = this.props

        groupStackExportMembers(groupId, groupName)
    }

    monitorGroupMouseEnter = () => {
        this.setState({ groupButtonHover: true })
    }

    monitorGroupMouseLeave = () => {
        this.setState({ groupButtonHover: false })
    }

    render() {
        const {
            isMonitored,
            groupId,
            members,
            groupStackState: {
                groupData: { loading },
                importData: { importing },
            },
        } = this.props

        return (
            <div className={'group-stack-header-buttons-area'}>
                <Button
                    buttonText={<FormattedMessage id={`${LOCALE_PREFIX}.groupExport`} />}
                    buttonKey={BUTTONS.XLS}
                    clickHandler={this.handleExportGroup}
                    disabled={loading || importing}
                />

                <Button
                    buttonText={<FormattedMessage id={`${LOCALE_PREFIX}.deleteAllGroupMembers`} />}
                    buttonKey={BUTTONS.DELETE}
                    clickHandler={this.handleDeleteAllGroupMembers}
                    disabled={members.count() === 0 || loading || importing}
                />

                <Button
                    buttonText={<FormattedMessage id={this.getMonitorButtonText()} />}
                    buttonKey={BUTTONS.MONITORING}
                    disabled={loading || importing}
                    clickHandler={this.handleMonitorGroup}
                    active={isMonitored}
                    mouseEnterHandler={this.monitorGroupMouseEnter}
                    mouseLeaveHandler={this.monitorGroupMouseLeave}
                />

                <Button
                    buttonText={<FormattedMessage id={`${LOCALE_PREFIX}.importToGroup`} />}
                    clickHandler={this.handleImportGroupMembers}
                    buttonKey={BUTTONS.IMPORT}
                    disabled={loading || importing}
                />

                <FilterButton groupId={groupId} buttonKey={BUTTONS.FILTER} disabled={loading || importing} />

                {/* <Button
                    index={'search'}
                /> */}

                <CloseButton onClick={this.handleCloseGroupStack} pad={4} size={22} />
            </div>
        )
    }
}
